var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","vectorEffect":"non-scaling-stroke","d":"M39 20c0 10.494-8.506 19-19 19S1 30.494 1 20 9.506 1 20 1s19 8.506 19 19Zm-21.85 9.5a2.85 2.85 0 1 0 5.7 0V18.1a2.85 2.85 0 0 0-5.7 0v11.4ZM20 13.35a2.85 2.85 0 1 1 0-5.7 2.85 2.85 0 0 1 0 5.7Z","fillRule":"evenodd"}));
}

Info.defaultProps = {"xmlSpace":"preserve","viewBox":"0 0 40 40"};

module.exports = Info;

Info.default = Info;
